(function($) {
  var svg = document.querySelectorAll('img.js-inject');
  SVGInjector(svg);
})(jQuery); 